'use client';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { useFormContext } from 'react-hook-form';
import LoadingButton from '@mui/lab/LoadingButton';
import { type SignUpDetails } from '@/schemas/signupSchema';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Stack } from '@mui/system';

interface SignupDetailsFormProps {
  disabledFields?: string[];
  buttonText?: string;
  disclaimerText?: string;
}

const SignupDetailsForm = ({
  disabledFields,
  buttonText = 'CREATE ACCOUNT & CONTINUE',
  disclaimerText = 'Secure & encrypted • No payment required yet'
}: SignupDetailsFormProps) => {
  const { register, formState } = useFormContext<SignUpDetails>();
  const { errors, isValid, isSubmitting } = formState;

  return (
    <Stack useFlexGap textAlign='center'>
      <Grid container>
        <Grid xs={12} sm={6}>
          <TextField
            required
            fullWidth
            id='firstName'
            label='First name'
            {...register('firstName')}
            disabled={disabledFields?.includes('firstName')}
            error={!!errors.firstName}
            helperText={errors.firstName?.message}
          />
        </Grid>
        <Grid xs={12} sm={6}>
          <TextField
            required
            fullWidth
            id='lastName'
            label='Last name'
            {...register('lastName')}
            disabled={disabledFields?.includes('lastName')}
            error={!!errors.lastName}
            helperText={errors.lastName?.message}
          />
        </Grid>
        <Grid xs={12}>
          <TextField
            required
            fullWidth
            id='email'
            label='Email Address'
            autoComplete='email'
            {...register('email')}
            disabled={disabledFields?.includes('email')}
            error={!!errors.email}
            helperText={errors.email?.message}
          />
        </Grid>
        <Grid xs={12}>
          <TextField
            required
            fullWidth
            id='mobile'
            label='Mobile number'
            {...register('mobile')}
            disabled={disabledFields?.includes('mobile')}
            error={!!errors.mobile}
            helperText={errors.mobile?.message}
          />
        </Grid>
      </Grid>
      <Typography variant='body1'>
        By submitting your information, you agree to The Urban Developer’s
        Privacy Policy and Terms and Conditions, and to receive newsletters from
        The Urban Developer. You can unsubscribe at any time.
      </Typography>
      <LoadingButton
        type='submit'
        loading={isSubmitting}
        disabled={!isValid}
        variant='contained'
        color='primary'
        disableElevation
        endIcon={<ArrowForwardOutlinedIcon />}
      >
        {buttonText}
      </LoadingButton>
      <Typography variant='caption'>
        <LockOutlinedIcon fontSize='small' sx={{ verticalAlign: 'middle' }} />{' '}
        {disclaimerText}
      </Typography>
    </Stack>
  );
};
export default SignupDetailsForm;
